import {createSlice} from '@reduxjs/toolkit';
import type {PayloadAction} from '@reduxjs/toolkit';

interface SystemConfigPropertyState {
	state: 'VolTE' | 'Data';
}

const initialState: SystemConfigPropertyState = {
	state: 'Data',
};

const systemConfigPropertySlice = createSlice({
	name: 'systemConfigProperty',
	initialState,
	reducers: {
		updateState: (state, action: PayloadAction<boolean | string>) => {
			const isData = action?.payload === true || action?.payload === 'true';
			state.state = isData ? 'Data' : 'VolTE';
		},
	},
});

export const {updateState} = systemConfigPropertySlice.actions;

export default systemConfigPropertySlice.reducer;
